import Assessment from './assessments'
import BillPackages from './bill-packages'
import Bills from './bills'
import Collaborators from './collaborators'
import Documents from './documents'
import Lessons from './lessons'
import Modules from './modules'
import NewAssessment from './new-assessment'
import Settings from './settings'
import Students from './students'

const Admin = {
  Students,
  Collaborators,
  Modules,
  Lessons,
  Assessment,
  Settings,
  Bills,
  NewAssessment,
  Documents,
  BillPackages,
}

export { Admin }
